import React from "react";

// Components
import Slider from "./slider";
import Button from "../../components/buttons";
import Open from "./open";

function Selectors({ onChange, item = {} }) {
    if (item.open) {
        return <Open onChange={onChange} />;
    }

    if (item.slider) {
        return <Slider onChange={onChange} {...item} />;
    }

    if (item.intro) {
        return (
            <Button
                text="Volgende"
                className="mt-m full"
                onClick={onChange}
            ></Button>
        );
    }

    return null;
}

export default Selectors;
